import React from 'react';
import styled from 'styled-components';
import { SectionTitle } from '../shared';

const Section = styled.section`
  background-color: #fff;
  padding: 6rem 2rem;
`;

const Slider = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  gap: 2rem;
  padding-bottom: 1rem;
  justify-content: center;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const Card = styled.div`
  flex: 0 0 50%;
  max-width: 350px;
  background: #fafafa;
  border-left: 4px solid ${(props) => props.theme.colors.darkRed};
  border-radius: 12px;
  padding: 2.5rem;
  scroll-snap-align: start;
  box-shadow: 0 12px 24px rgba(0,0,0,0.06);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;

const QuoteText = styled.p`
  position: relative;
  padding-left: 1.5rem;
  font-style: italic;
  margin-bottom: 1rem;
  line-height: 1.6;
  font-size: 1.1rem;
  &::before {
    content: '“';
    position: absolute;
    left: 0;
    top: 0;
    font-size: 2.5rem;
    color: ${(props) => props.theme.colors.darkRed};
    line-height: 1;
  }
`;

const Author = styled.p`
  text-align: right;
  font-style: italic;
  font-size: 0.9rem;
  margin-top: 1rem;
  color: ${(props) => props.theme.colors.darkGray};
`;

const testimonials = [
  {
    text: "I feel like I found a great community of people in the industry. I feel much more confident in my ability to execute my podcast project and make it successful. The instructors were available and very helpful, so I always feel like I have some support.",
    author: '',
  },
  {
    text: "It's the best thing that I've done for me in a LONG time.",
    author: 'Jesse Denney',
  },
  {
    text: "I nailed down my show idea and got a lot of good feedback on everything, I got to flex a little bit with my voice and editing experience helping with other projects, and the program helped me realize that I wanted to start my own business!",
    author: 'Jesse Denney',
  },
  {
    text: "I really felt I got a much deeper understanding of the craft and business than I expected.",
    author: '',
  },
  {
    text: "I am very grateful for this opportunity to learn from such wise and generous instructors. I believe you are on to something fantastic and [this program] is a real resource in an industry that is otherwise hard to get a handle on. Thank you.",
    author: 'Andrea Learned',
  },
  {
    text: "Great instructors and great classmates. I am so glad I took a chance on myself and joined this program.",
    author: 'Roni Polsgrove',
  },
  {
    text: "I loved hearing all my classmates' ideas and learning how to do audio and video editing.",
    author: 'Ryan Baile',
  },
  {
    text: "Strongest Aspects of the Program: Encouragement, availability amongst teachers, camaraderie.",
    author: '',
  },
  {
    text: "It’s like a graduate course. Nothing like it or better out there, I’m convinced. Complete transformer and game changer. Very impressed by this course and will be applying my learnings from here on out.",
    author: '',
  },
  {
    text: "This program really encourages you to try out and pursue the passion projects that many have been formalizing for so long. It's also so helpful to have a cohort/ teachers in your back pocket so you don't have to work through the challenges of development on your own.",
    author: 'Anuli Ononye',
  },
  {
    text: "The credibility I obtained by having the Stony Brook name behind me has helped me advance in the field. One of the guest speakers told us it’s more effective to build an audience by getting invited on others’ podcasts. I’ve now been invited on two, including one really big one.",
    author: 'Genna Buck',
  },
  {
    text: "It was really good to get practice getting formal feedback, including from outside people. The practice we cultivated of making timed pitches and taking feedback without answering was really helpful for me.",
    author: 'Genna Buck',
  },
  {
    text: "I'M PUMPED!! Feels like Phase 1 of My Most Authentic Life is complete, the foundation has been set and now it's time to build upwards.",
    author: 'Fede Vargas',
  },
  {
    text: "After exiting a career in marketing and comms, the class revived my creativity and gave me so many new skills to broaden my search and also leading me in new directions to build. Feeling very good about affirmed my talent and skills.",
    author: 'Phoebe Lyng Dudley',
  },
];

const Testimonials: React.FC = () => (
  <Section>
    <SectionTitle color="black">Podcast Incubator Testimonials</SectionTitle>
    <Slider>
      {testimonials.map((t, idx) => (
        <Card key={idx}>
          <QuoteText>{t.text}</QuoteText>
          {t.author && <Author>- {t.author}</Author>}
        </Card>
      ))}
    </Slider>
  </Section>
);

export default Testimonials;